import React, { useEffect, useState } from "react";
import axios from "axios";

const ExceptionReporting = () => {
  const [actionables, setActionables] = useState([]);
  const [selectedActionables, setSelectedActionables] = useState([]);
  const [report, setReport] = useState("");
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [search, setSearch] = useState("");

  const [exceptionType, setExceptionType] = useState("");
  const [otherType, setOtherType] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) return;

    axios
      .get("/api/actionables/actionables-list/", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setActionables(res.data))
      .catch(() => setMessage("⚠️ Failed to load actionable list"));
  }, []);

  const getKey = (a) => `${a.actionable_number}||${a.end_date || "No End Date"}`;

  const toggleActionable = (key) => {
    setSelectedActionables((prev) =>
      prev.includes(key)
        ? prev.filter((k) => k !== key)
        : [...prev, key]
    );
  };

  const filteredActionables = actionables.filter(
    (a) =>
      a.actionable_number.toLowerCase().includes(search.toLowerCase()) ||
      (a.end_date && a.end_date.toLowerCase().includes(search.toLowerCase()))
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("accessToken");

    if (!exceptionType) {
      setMessage("❌ Please select exception type.");
      return;
    }

    if (exceptionType === "Other" && !otherType.trim()) {
      setMessage("❌ Please specify other exception type.");
      return;
    }

    const formData = new FormData();
    selectedActionables.forEach((key) =>
      formData.append("actionables", key.split("||")[0])
    );

    formData.append("report", report);
    formData.append("type", exceptionType);

    if (exceptionType === "Other") {
      formData.append("other_type", otherType);
    }

    if (file) formData.append("images", file);

    try {
      const res = await axios.post(
        "/api/actionables/exception-report/",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setMessage(res.data.message);
      setReport("");
      setSelectedActionables([]);
      setFile(null);
      setExceptionType("");
      setOtherType("");
    } catch {
      setMessage("❌ Failed to submit report.");
    }
  };

  return (
    <div className="page-container">
      <div className="card">
        <h1>Exception Reporting</h1>

        {/* SEARCH */}
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search by actionable number or end date..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <form onSubmit={handleSubmit}>
          {/* ACTIONABLE LIST */}
          <div className="actionable-list">
            {filteredActionables.length > 0 ? (
              filteredActionables.map((a) => {
                const key = getKey(a);
                const selected = selectedActionables.includes(key);
                return (
                  <label
                    key={key}
                    className={`actionable-item ${selected ? "selected" : ""}`}
                  >
                    <input
                      type="checkbox"
                      checked={selected}
                      onChange={() => toggleActionable(key)}
                    />
                    <div className="actionable-info">
                      <span className="number">{a.actionable_number}</span>
                      <span className="date">
                        {a.end_date || "No End Date"}
                      </span>
                    </div>
                  </label>
                );
              })
            ) : (
              <div className="loading">No matching actionables found</div>
            )}
          </div>

          {/* SELECTED TAGS */}
          {selectedActionables.length > 0 && (
            <div className="selected-section">
              <h3>Selected Actionables</h3>
              <div className="selected-tags">
                {selectedActionables.map((key) => {
                  const [num, date] = key.split("||");
                  return (
                    <div key={key} className="tag">
                      {num} — {date}
                      <button
                        type="button"
                        onClick={() =>
                          setSelectedActionables((prev) =>
                            prev.filter((k) => k !== key)
                          )
                        }
                      >
                        ×
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* EXCEPTION TYPE */}
          <div className="form-group">
            <label>Exception Type</label>
            <div className="radio-group">
              {["Operational", "Technical", "Other"].map((t) => (
                <label key={t}>
                  <input
                    type="radio"
                    name="exceptionType"
                    value={t}
                    checked={exceptionType === t}
                    onChange={(e) => setExceptionType(e.target.value)}
                  />{" "}
                  {t}
                </label>
              ))}
            </div>

            {exceptionType === "Other" && (
              <input
                type="text"
                className="text-input"
                placeholder="Specify other exception type"
                value={otherType}
                onChange={(e) => setOtherType(e.target.value)}
              />
            )}
          </div>

          {/* REPORT */}
          <div className="form-group">
            <label>Report Description</label>
            <textarea
              value={report}
              onChange={(e) => setReport(e.target.value)}
              placeholder="Describe the issue..."
              required
            />
          </div>

          {/* FILE */}
          <div className="form-group">
            <label>Upload Supporting File</label>
            <input
              type="file"
              onChange={(e) => setFile(e.target.files[0])}
            />
            {file && <small>Selected: {file.name}</small>}
          </div>

          <button type="submit" className="submit-btn">
            Submit Report
          </button>
        </form>

        {message && <p className="message">{message}</p>}
      </div>

      {/* FIXED & SAFE CSS */}
      <style>{`
        .page-container {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          background: linear-gradient(135deg, #e8f0ff, #f8fbff);
          padding: 40px 20px;
        }
        .card {
          background: #fff;
          width: 900px;
          max-width: 100%;
          border-radius: 16px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.1);
          padding: 30px 40px;
        }
        .card h1 {
          text-align: center;
          margin-bottom: 25px;
          color: #0f1d60;
        }
        .search-bar {
          margin-bottom: 20px;
        }
        .search-bar input {
          width: 100%;
          padding: 12px;
          border-radius: 10px;
          border: 1px solid #ccc;
        }
        .actionable-list {
          max-height: 260px;
          overflow-y: auto;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          padding: 12px;
          margin-bottom: 20px;
        }
        .actionable-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px;
          border-radius: 10px;
          border: 1px solid #e5e7eb;
          margin-bottom: 10px;
          background: #fff;
        }
        .actionable-item.selected {
          background: #e0ebff;
        }
        .actionable-info {
          display: flex;
          flex-direction: column;
        }
        .number {
          font-weight: 600;
        }
        .selected-section {
          margin-bottom: 25px;
        }
        .selected-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }
        .tag {
          background: #e0ebff;
          padding: 6px 10px;
          border-radius: 20px;
          display: flex;
          gap: 8px;
          align-items: center;
        }
        .form-group {
          margin-bottom: 20px;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .radio-group {
          display: flex;
          gap: 25px;
        }
        textarea {
          min-height: 120px;
          padding: 12px;
          border-radius: 10px;
          border: 1px solid #ccc;
        }
        .submit-btn {
          width: 100%;
          padding: 14px;
          background: #0f1d60;
          color: white;
          border-radius: 10px;
          border: none;
          margin-top: 10px;
        }
        .message {
          margin-top: 15px;
          text-align: center;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
};

export default ExceptionReporting;
